export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-shape/src/array.js
// module id = ./node_modules/d3-shape/src/array.js
// module chunks = vendor